/* eslint-disable require-jsdoc */
import React from 'react';
import PropTypes from 'prop-types';
import {isValid} from '../../utils/validate';


const Sort = (props) => {
  return (
    <div className="hearby-carousel-controls-item hearby-cci-sort">
      <select
        name="sort"
        className="hearby-cc-select-menu hearby-sort"
        onChange={props.change}

        defaultValue={isValid(props.defaultSortValue) ?
          props.defaultSortValue : 'date'}
      >
        <option value="artist">Artist</option>
        <option value="venue">Venues</option>
        <option value="distance">Distance</option>
        <option value="date">Date</option>
      </select>
    </div>
  );
};

Sort.propTypes = {
  change: PropTypes.func.isRequired,
  defaultSortValue: PropTypes.string.isRequired,
};

export default Sort;
